import React, { useEffect, useState, useRef } from "react";
import "croppie/croppie.css";
import { Col, Row, Spinner } from "reactstrap";
import { connect } from "react-redux";
import Slider, { createSliderWithTooltip } from "rc-slider";
import Rotate90DegreesCcwIcon from "@material-ui/icons/Rotate90DegreesCcw";
import { Button, IconButton, LinearProgress } from "@material-ui/core";
import CropIcon from "@material-ui/icons/Crop";
import SaveIcon from "@material-ui/icons/Save";
/* import "./ProfileImageUploader.css"; */
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ReplayIcon from "@material-ui/icons/Replay";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { securityHelper } from "../../../../helpers/securityHelper";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RotateRightIcon from "@material-ui/icons/RotateRight";
const Croppie = require("croppie");
const SliderWithTooltip = createSliderWithTooltip(Slider);

const DEFAULT_IMAGE =
  "https://www.xovi.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";

const ProfileImageUploader = (props) => {
  const [source, setSource] = useState("");
  const [isCropping, setIsCropping] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const imgRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setSource(props.source);
  }, []);

  useEffect(() => {
    if (source) setSource(props.source);
  }, [props.source]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const onImageUpload = async (e) => {
    const { cms, dispatch, element } = props;

    const file = e.target.files[0];
    const result = await toBase64(file).catch((e) => Error(e));
    if (result instanceof Error) {
      console.error("Error: ", result.message);
      return;
    }
    setIsCropping(true);
    setSource(result);

    if (fileInputRef.current.files) {
      fileInputRef.current.value = "";
    }
  };
  const onDelete = () => {
    props.onDeleteImage();
  };
  const setImageOnOrder = (source) => {
    setSource(source);
    props.setImage(source);
    //props.load
  };
  const onCropped = (source) => {
    setIsCropping(false);
    setImageOnOrder(source);
  };

  const setImageClassName = (type) => {
    switch (type) {
      case "SQUARE":
        return "square--landscape";
      case "CIRCLE":
        return "circular--landscape";
      default:
        return "";
    }
  };
  const handleImageLoaded = () => setImageLoaded({ imageLoaded: true });
  const { cms, template } = props;

  return (
    <div
      className="w-100 "
      style={{ padding: 15, display: "flex", flexDirection: "column" }}
    >
      {!isCropping && (
        <div
          className={`image-container da responsive-col-image-alignment ${setImageClassName(
            "CIRCLE"
          )}`}
          style={{ width: "150px", height: "150px" }}
        >
          <img
            ref={imgRef}
            onLoad={handleImageLoaded}
            src={source || DEFAULT_IMAGE}
            className={`image-content ${imageLoaded ? "unblur" : "blur"}`}
            alt="image"
          />
        </div>
      )}

      <div
        style={{
          /*           margin: "10px auto", */
          marginBottom: 0 /* , marginTop: isCropping ? '40px' : 0 */,
        }}
      >
        {isCropping ? (
          <ProfileImageCropper
            source={source}
            shape={"circle"}
            onClose={() => setIsCropping(false)}
            size={{ height: 800, width: 800 }}
            viewport={{ height: 150, width: 150 }}
            parentId={securityHelper.createGuid()}
            onCropped={onCropped}
            backgroundColor={"#fff"}
          />
        ) : null}

        {!isCropping ? (
          <>
            <div className="croppie-toolbar" style={{ marginTop: 25 }}>
              <Row>
                <Col style={{ width: "50%", textAlign: "center" }}>
                  <Button
                    disabled={!source.includes("data:image")}
                    variant="contained"
                    color="default"
                    style={{
                      width: "100%",
                      boxShadow: "none",
                      background: "#eee",
                    }}
                    startIcon={<CropIcon style={{ fontSize: 20 }} />}
                    onClick={() => setIsCropping(true)}
                  >
                    <SystemLabel name="Crop" />
                  </Button>
                </Col>
                <Col style={{ width: "50%", textAlign: "center" }}>
                  <Button
                    disabled={!source}
                    variant="contained"
                    color="default"
                    style={{
                      width: "100%",
                      boxShadow: "none",
                      background: "#eee",
                    }}
                    startIcon={<DeleteIcon />}
                    onClick={() => onDelete()}
                  >
                    <SystemLabel name="Delete" /*  lang="swe" */ />
                  </Button>
                </Col>
              </Row>
            </div>
            <div className="croppie-toolbar">
              <Row>
                <Col style={{ textAlign: "center" }}>
                  <label
                    htmlFor="file-upload-pfi"
                    className="custom-primary-button"
                  >
                    <CloudUploadIcon />{" "}
                    <SystemLabel name="UploadImage" lang="swe" />
                  </label>
                </Col>
              </Row>
            </div>
          </>
        ) : null}
      </div>

      <input
        ref={fileInputRef}
        id="file-upload-pfi"
        className="file-upload"
        type="file"
        accept="png,jpg,svg"
        /* multiple */ onChange={(e) => {
          try {
            onImageUpload(e);
          } catch (error) {
            console.error(error);
          }
        }}
      />
    </div>
  );
};
function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template.template,
    cms: state.cms,
    attendee: state.attendee,
  };
}
export default connect(mapStateToProps)(ProfileImageUploader);

class ProfileImageCropper extends React.Component {
  state = {
    zoom: 0,
    isLoading: false,
  };
  componentDidMount() {
    this.init();
  }
  init = (reRender = false) => {
    const { size, shape, parentId, viewport, backgroundColor } = this.props;

    if (this.cropper) {
      this.cropper.destroy();
    }
    if (size !== null || reRender) {
      this.cropper = new Croppie(
        document.getElementById("croppie-img-" + parentId),
        {
          viewport: { ...viewport, type: shape.toLowerCase() },
          boundary: viewport,
          showZoomer: true,
          type: "base64",
          enableOrientation: true,
        }
      );

      this.handleZoomOut(0);
      let listNodes = document.getElementsByClassName("cr-vp-square");

      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
      listNodes = document.getElementsByClassName("cr-vp-circle");
      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
    }
  };
  componentDidUpdate(prevProps) {
    const { hideOverlay, size, source, isCropping } = this.props;
    if (
      hideOverlay !== undefined &&
      prevProps.hideOverlay !== hideOverlay &&
      hideOverlay == false
    ) {
      this.init(true);
    }

    if (source && prevProps.source !== source) {
      this.init();
    }
    if (isCropping !== isCropping) {
      this.init();
    }
  }

  handleZoomOut = (scale, controlled = false) => {
    if (this.cropper !== undefined) {
      const cZoom = this.cropper.get().zoom;
      if (!controlled && scale === 0) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (controlled === true && scale !== undefined) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (cZoom !== this.state.zoom) {
        if (cZoom === 50) {
          this.cropper.setZoom(0);
          this.setState({ zoom: 0 });
          return;
        }
        this.setState({ zoom: cZoom });
      }
    }
  };
  handleResult = () => {
    const { size } = this.props;
    this.setState({ isLoading: true });
    this.cropper
      .result({ type: "base64", size })
      .then((res) => this.handleSave(res));
  };
  handleSave = (res) => {
    const { onCropped } = this.props;
    onCropped(res);
  };
  close = () => {
    const { onClose } = this.props;
    onClose();
  };
  rotate = (rotation) => {
    this.cropper.rotate(rotation);
  };
  render() {
    const { shape, size, parentId, viewport, hideOverlay, source } = this.props;
    return (
      <React.Fragment>
        <div>
          {this.state.isLoading ? <LinearProgress /> : null}
          <div
            id="inline-croppie-overlay"
            onWheel={this.handleZoomOut}
            className="inline-croppie-overlay-da"
            style={{ width: "100%", paddingBottom: 0, position: "relative" }}
          >
            <img id={`croppie-img-${parentId}`} src={`${source}`} />
            <div
              style={{ width: "50%", left: `25%`, bottom: "12px" }}
              className={`croppie-controllers-da pi-crop  `}
            ></div>
          </div>
          <div className="croppie-toolbar">
            <Row>
              <Col style={{ width: "50%", textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="default"
                  style={{
                    width: "100%",
                    boxShadow: "none",
                    background: "#eee",
                  }}
                  startIcon={<RotateLeftIcon />}
                  onClick={() => this.rotate(90)}
                >
                  <SystemLabel name="RotateLeft" />
                </Button>
              </Col>
              <Col style={{ width: "50%", textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="default"
                  style={{
                    width: "100%",
                    boxShadow: "none",
                    background: "#eee",
                  }}
                  startIcon={<RotateRightIcon />}
                  onClick={() => this.rotate(-90)}
                >
                  <SystemLabel name="RotateRight" />
                </Button>
              </Col>
            </Row>
          </div>
          <div className="croppie-toolbar">
            <Row style={{ marginBottom: 8 }}>
              <Col style={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="default"
                  style={{
                    width: "100%",
                    boxShadow: "none",
                    background: "#eee",
                  }}
                  startIcon={<CloseIcon />}
                  onClick={() => this.close()}
                >
                  <SystemLabel name="Cancel" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col style={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: "100%" }}
                  startIcon={<CheckIcon />}
                  onClick={() => this.handleResult()}
                >
                  <SystemLabel name="SaveChanges" />
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
